import * as React from "react";
import SwipeableViews from "react-swipeable-views";
import { observer } from "mobx-react";
import i18n from "i18n";
import { Paiment, Price } from "common/icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  IconButton,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import {
  withStyles,
  WithStyles,
  createStyles,
  Theme,
} from "@material-ui/core/styles";
import { ArrowDropDown, Close } from "@material-ui/icons";

import { WBSStore } from "modules/WBS/WBSStore";
import { CostPlanStore } from "modules/costPlan/CostPlanStore";
import WBSTable from "modules/WBS/components/layouts/WBSTable";
import WBSResources from "modules/WBS/components/layouts/WBSResources";
import ToggleTabs from "modules/WBS/components/layouts/ToggleTabs";
import { ToolbarStore } from "modules/WBS/ToolbarStore";
import { ToolbarTaskStore } from "modules/WBS/ToolbarTaskStore";
import { LoginStore } from "modules/login/LoginStore";
import { ProjectStore } from "modules/project/ProjectStore";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import { Render3dStore } from "modules/render3D/Render3dStore";
import { NoResultsFound } from "modules/development/components/layouts";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { WBSPropertiesStore } from "modules/WBS/WBSPropertiesStore";
import ReplicateModal from "../layouts/Replicate";
import ExportByGroupModal from "../layouts/ExportByGroup";
import XeokitViewer from "../layouts/XeokitViewer";
import PriceCard from "modules/WBS/components/layouts/PriceCard";
import FormulaField from "common/components/FormulaField";
import { ELeftMenuTab, ERowType } from "common/enums";
import StarRecalc from "modules/WBS/components/layouts/StarRecalc";
import ChangeQuantityModal from "modules/WBS/components/layouts/ChangeQuantityModal";

const PropTypes = require("prop-types");

const styles = (theme: Theme) =>
  createStyles({
    gridContainer: {
      height: "calc(100vh - 131px)",
      display: "grid",
      gridTemplateRows: "60px 40px 1fr",
    },
    gridContainer1: {
      display: "grid",
    },
    mainBar: {
      backgroundColor: "#FFFFFF",
      display: "flex",
      alignItems: "center",
      paddingLeft: "20px",
      paddingRight: "20px",
    },
    mainBarText: {
      fontFamily: "Roboto",
      fontSize: "14px",
      fontWeight: 700,
      color: "#666",
    },
    spanSum: {
      marginLeft: "auto",
      "&:nth-child(2)": {
        marginLeft: "24px",
      },
    },
    tabBar: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    swipeableViews: {
      backgroundColor: "#FFFFFF",
    },
    tableStageLine: {
      fontWeight: 700,
      "& input": {
        fontWeight: 700,
      },
      "& td": {
        fontWeight: 700,
      },
    },
    tableFirstStageLine: {
      textTransform: "uppercase" as any,
      "& input": {
        textTransform: "uppercase" as any,
      },
      "& td": {
        textTransform: "uppercase" as any,
      },
    },
    closeIcon: {
      color: "#fff",
      right: "20px",
      top: "14px",
    },
    confirmButton: {
      cursor: "pointer",
      padding: "8px 16px",
      color: "#ABC200",
    },
    loaderModelMap: {
      height: "100%",
      width: "100%",
      background: "rgba(245, 245, 245)",
      position: "absolute",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 10,
    },
    progress: {
      margin: 0,
      color: "#ABC200",
      width: "90px !important",
      height: "90px !important",
    },
    root: {
      display: "flex",
      flex: 1,
      "flex-direction": "column",
      height: "100%",
      backgroundColor: "#e6e6e6",
      //background: "#D3D3D3",
    },
    headerContainer: {
      display: "flex",
      flex: 1,
    },
    sliderContainer: {
      display: "flex",
      paddingTop: "0.2em",
      paddingRight: "2em",
      position: "absolute",
      right: 0,
      top: 0,
      height: "85%",
    },
    slider: {
      overflow: "hidden",
      padding: "1.7rem 1.8rem",
    },
    sliderThumb: {
      width: "18px !important",
      height: "18px !important",
      backgroundColor: "#90CAF9 !important",
    },
    sliderTrack: {
      width: "8px !important",
      borderRadius: 26,
    },
    sliderTrackBefore: {
      backgroundColor: "#90CAF9 !important",
    },
    boxValues: {
      display: "flex",
      flexDirection: "row" as any,
      alignItems: "center",
    },
  });

function TabContainer({ children }) {
  return <Typography component="div">{children}</Typography>;
}

TabContainer.propTypes = {
  children: PropTypes.node,
};

type IProps = {
  url: string;
};

@observer
class WBS extends React.Component<WithStyles<typeof styles> & IProps> {
  state = {
    open: false,
    developmentSelected: "",
    wbsSelected: "",
    renderWithIsolate: "",
    value: "",
  };

  constructor(props) {
    super(props);
    let id = WBSStore.WBS.id;
    if (props.match && props.match.params) id = props.match.params.id;
    WBSStore.display3D = "hidden";
  }
  componentWillReceiveProps(nextProps: any) {
    let id = WBSStore.WBS.id;
    CostPlanStore.currentCostPlanExport(WBSStore.currentWbsId);
    if ((this.props as any).match && (this.props as any).match.params)
      id = (this.props as any).match.params.id;

    if (
      id === "Development" &&
      DevelopmentStore.developmentSelected.id !== nextProps.match.params.id
    ) {
      Render3dStore.modelIdCollection.map((model: any) => {
        let myModel = Render3dStore.xeokitViewer.scene.models[model.model];
        // Destroy the model
        if (!myModel) {
          console.error("Model not loaded: " + model.model);
          return;
        }
        myModel.destroy();
      }); //PRUBK-754
      WBSStore.get3dModel(nextProps.match.params.id);
    }
  }

  handleModalToggle = (open: boolean) => () => this.setState({ open });

  handleTabChange = (event, tab) => (WBSStore.tab = tab);

  handleWBSTableChange = async (line, index, ref, clmn, newValue) => {
    if ((clmn == "quantity" || clmn == "unitCost") && isNaN(newValue)) {
      return;
    }
    if (clmn == "description" && newValue == "") {
      newValue = "Descrição não preenchida";
    }
    await WBSStore.handleWBSTableChange(line, index, ref, clmn, newValue);
  };

  handleConfirmRecalculation = () =>
    this.setState({ open: false }, () => WBSStore.changeDecimalAndRule());

  handleFormulaSave = (ev, newFormula: string) => {
    const selectedLine = { ...WBSStore.selectedLine };
    if (!selectedLine == undefined) return;

    const lineFormula = selectedLine.data.formula;
    const lineQtt = selectedLine.data.quantity;

    const dataToUndo = {
      originalOperation: "applyFormula",
      undoOperation: "applyFormula",
      data: {
        undoFunction: {
          function: "applyFormula",
          params: [lineFormula, selectedLine, lineQtt],
          selectedLine: [],
        },
        originalFunction: {
          function: "applyFormula",
          params: [newFormula, selectedLine],
        },
      },
    };

    // Efetua chamada da função responsável por validar e persistir as informações da fórmula definida pelo usuário
    if (selectedLine.data.parentTask) {
      // Caso seja inserido no sistema a atribuição de formula as TeskRows já está senfo verificada se a linha selecionada é uma TaskRow
      ToolbarTaskStore.handelActions(
        WBSPropertiesStore.applyFormula(newFormula, selectedLine),
        dataToUndo
      );
    } else {
      WBSPropertiesStore.applyFormula(newFormula, selectedLine);
      ToolbarStore.handelActions(dataToUndo);
    }
  };

  render() {
    const { classes, url } = this.props;
    const { decimalPlaces } = WBSStore.WBS.data;
    const { calculating } = WBSPropertiesStore;
    const selectedLine = { ...WBSStore.selectedLine };

    const disabled = (line, ref) => line.data.rowType === ERowType.STAGE;
    const warning = WBSPropertiesStore.needRecalculate;
    let heightGridContainer = LoginStore.isTrialUser()
      ? { height: "calc(100vh - 131px)" }
      : { height: "calc(100vh - 93px)" };

    let dev = DevelopmentStore.developmentSelected;
    let loadLayerProps;
    if (CostPlanStore.wbsSelected) {
      if (CostPlanStore.wbsSelected.data.status === "error")
        loadLayerProps = {
          error: true,
          title:
            i18n.rateLibraries.error.title +
            " Por favor, importe a planilha novamente",
          primaryButton: {
            label: i18n.rateLibraries.error.tryAgain,
            action: () => CostPlanStore.handleTryAgain(),
          },
          secondaryButton: {
            label: i18n.rateLibraries.error.cancel,
            action: () => CostPlanStore.handleCancel(),
          },
        };
      else if (CostPlanStore.wbsSelected.data.status === "columnNotFound")
        loadLayerProps = {
          error: true,
          title:
            i18n.wbs.error.columnNotFound +
            CostPlanStore.wbsSelected.data.message +
            " Por favor, importe a planilha novamente",
          secondaryButton: {
            label: i18n.rateLibraries.error.cancel,
            action: () => CostPlanStore.handleCancel(),
          },
        };
      else if (CostPlanStore.wbsSelected.data.progress !== 100)
        loadLayerProps = {
          title: i18n.wbs.processing,
          subtitle: CostPlanStore.wbsSelected.data.fileName,
          progress: CostPlanStore.wbsSelected.data.progress,
        };
    } else if (CostPlanStore.wbsSelected === false)
      loadLayerProps = { title: i18n.wbs.preparing };
    if (calculating) {
      let { title, subtitle } = i18n.wbs.calculating;
      loadLayerProps = { title, subtitle };
      WBSPropertiesStore.setCalculating(false);
    }

    let activatedColumns =
      WBSStore.WBS.data.bdi.show === true
        ? [
            {
              label: "Cód. EAP",
              dataKey: "tree",
              ref: "content",
              disabled: true,
              align: "left",
              width: WBSStore.maxCodeEapLength,
            },
            {
              label: "",
              dataKey: "link",
              ref: "content",
              disabled,
              align: "left",
              width: 25,
            },
            {
              label: "Descrição",
              dataKey: "description",
              ref: "content",
              indentation: true,
              align: "left",
              icon: {
                condition: (line) =>
                  line.data.rowType === ERowType.STAGE &&
                  line.data.tree.split(".").length > 1,
                component: ArrowDropDown,
              },
            },
            {
              label: "Quantidade",
              dataKey: "quantity",
              ref: "row",
              disabled,
              align: "center",
              width: "106px",
              numeric: {
                decimalScale: 8,
              },
            },
            {
              label: "Unidade",
              dataKey: "unit",
              ref: "content",
              disabled,
              align: "center",
              width: "116px",
            },
            {
              label: "Custo Unit. (R$)",
              dataKey: "unitCost",
              ref: "content",
              disabled,
              align: "right",
              width: "120px",
              numeric: {
                decimalScale: decimalPlaces,
                fixedDecimalScale: true,
              },
              link: {
                condition: (line) => line.data.rowType === ERowType.TASK,
                url: (line) => url + "/" + line.id,
              },
            },
            {
              label: "Total (R$)",
              dataKey: "total",
              ref: "row",
              disabled: true,
              align: "right",
              paddingRight: "10px",
              width: "112px",
              numeric: {
                decimalScale: 2,
                fixedDecimalScale: true,
              },
            },
            {
              label: "Preço de Venda (R$)",
              dataKey: "vendaBdi",
              ref: "row",
              disabled: true,
              align: "right",
              width: "141px",
              numeric: {
                decimalScale: decimalPlaces,
                fixedDecimalScale: true,
              },
            },
            {
              label: "Preço Total (R$)",
              dataKey: "totalBdi",
              ref: "row",
              disabled: true,
              align: "right",
              paddingRight: "10px",
              width: "130px",
              numeric: {
                decimalScale: 2,
                fixedDecimalScale: true,
              },
            },
            {
              label: "BDI (%)",
              dataKey: "bdi",
              ref: "row",
              disabled,
              align: "right",
              paddingRight: "10px",
              width: "95px",
              numeric: {
                decimalScale: 2,
                fixedDecimalScale: true,
              },
            },
          ]
        : [
            {
              label: "Cód. EAP",
              dataKey: "tree",
              ref: "content",
              disabled: true,
              align: "left",
              width: WBSStore.maxCodeEapLength,
            },
            {
              label: "",
              dataKey: "link",
              ref: "content",
              disabled,
              align: "left",
              width: 25,
            },
            {
              label: "Descrição",
              dataKey: "description",
              ref: "content",
              indentation: true,
              align: "left",
              icon: {
                condition: (line) =>
                  line.data.rowType === ERowType.STAGE &&
                  line.data.tree.split(".").length > 1,
                component: ArrowDropDown,
              },
            },
            {
              label: "Quantidade",
              dataKey: "quantity",
              ref: "row",
              disabled,
              align: "right",
              width: "106px",
              numeric: {
                decimalScale: 8,
              },
            },
            {
              label: "Unidade",
              dataKey: "unit",
              ref: "content",
              disabled,
              align: "center",
              width: "116px",
            },
            {
              label: "Custo Unit. (R$)",
              dataKey: "unitCost",
              ref: "content",
              disabled,
              align: "right",
              width: "120px",
              numeric: {
                decimalScale: decimalPlaces,
                fixedDecimalScale: true,
              },
              link: {
                condition: (line) => line.data.rowType === ERowType.TASK,
                url: (line) => url + "/" + line.id,
              },
            },
            {
              label: "Total (R$)",
              dataKey: "total",
              ref: "row",
              disabled: true,
              align: "right",
              paddingRight: "10px",
              width: "112px",
              numeric: {
                decimalScale: 2,
                fixedDecimalScale: true,
              },
            },
          ];

    if (
      TakeOffStore.statusModelmap === "Loading" ||
      (WBSStore.loading && WBSStore.tab == 0) ||
      WBSStore.loadingTaskChange ||
      WBSStore.loadingInsertTask
    ) {
      return (
        <div className={classes.loaderModelMap}>
          <CircularProgress
            className={classes.progress}
            variant="indeterminate"
          />
          <Typography
            style={{
              position: "absolute",
              marginTop: "170px",
            }}
          >
            {WBSStore.calculatingMessage ||
              `${i18n.wbs.calculating.subtitle}...`}
          </Typography>
        </div>
      );
    }

    const functionEnabled =
      WBSStore.tab === 0 &&
      selectedLine &&
      selectedLine.data &&
      (selectedLine.data.rowType == ERowType.RESOURCE ||
        selectedLine.data.rowType == ERowType.TASK) &&
      !selectedLine.data.fromModelMap &&
      WBSStore.editingFormula;
    const formulaOptions = [
      ["builtArea", "m²"],
      ["equivalentArea", "m²"],
      ["landArea", "m²"],
      ["privateArea", "m²"],
      ["privateUnits", "un"],
      ["monthRelease", ""],
    ].map(([id, unit]) => ({
      id,
      label: i18n.project.rightSideMenu.WBSInfo[id],
      unit,
    }));

    return (
      <React.Fragment>
        <>
          <ChangeQuantityModal />
        </>
        {functionEnabled && (
          <div
            className={classes.mainBar}
            style={{ justifyContent: "space-between" }}
          >
            <FormulaField
              formula={selectedLine.data.formula}
              options={formulaOptions}
              onSave={this.handleFormulaSave}
            />
          </div>
        )}
        <div className={classes.gridContainer} style={heightGridContainer}>
          <StarRecalc></StarRecalc>
          <div
            className={classes.mainBar}
            style={{ justifyContent: "space-between" }}
          >
            <Typography className={classes.mainBarText} component="span">
              {i18n.wbs.principal}
            </Typography>
            <div className={classes.boxValues}>
              <div className={classes.spanSum}>
                <PriceCard
                  Icon={<Paiment />}
                  sum={WBSStore.currentWbsTotalCost}
                  title={i18n.wbs.totalcost}
                  {...(warning && {
                    warning: true,
                    tooltip: i18n.wbs.calculating.tooltip,
                    onClick: this.handleModalToggle(true),
                  })}
                />
              </div>
              {WBSStore.WBS.data.bdi.show == true && (
                <div className={classes.spanSum}>
                  <PriceCard
                    Icon={<Price />}
                    sum={WBSStore.currentWbsTotalSaleCost}
                    title={i18n.wbs.totalsales}
                    waring={false}
                  />
                </div>
              )}
            </div>
          </div>
          <div className={classes.tabBar}>
            <ToggleTabs
              value={WBSStore.tab}
              onChange={this.handleTabChange}
              tabs={[
                {
                  label: "EAP",
                },
                {
                  label: "INSUMOS",
                },
              ]}
            />
          </div>
          <SwipeableViews
            axis={"x"}
            index={WBSStore.tab}
            className={classes.swipeableViews}
            style={{
              overflow: "hidden",
            }}
          >
            <TabContainer>
              {!WBSStore.loadingDataTable && (
                <WBSTable
                  columns={activatedColumns}
                  styleLine={[
                    {
                      className: classes.tableStageLine,
                      condition: (line, ref) =>
                        line.data.rowType === ERowType.STAGE,
                    },
                    {
                      className: classes.tableFirstStageLine,
                      condition: (line, ref) =>
                        line.data.rowType === ERowType.STAGE &&
                        ref.split(".").length === 1,
                    },
                  ]}
                  onChange={this.handleWBSTableChange}
                />
              )}
            </TabContainer>
            <TabContainer>
              <WBSResources />
            </TabContainer>
          </SwipeableViews>
          <Dialog
            open={this.state.open}
            onClose={this.handleModalToggle(false)}
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
          >
            <DialogTitle
              style={{
                padding: "20px",
              }}
            >
              <p
                style={{
                  color: "#f2f2f2",
                  fontSize: "18px",
                  margin: 0,
                }}
              >
                {i18n.wbs.calculating.modal.title}
              </p>
              <IconButton
                onClick={this.handleModalToggle(false)}
                className={classes.closeIcon}
                style={{
                  position: "absolute",
                }}
              >
                <Close fontSize="small" />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                style={{
                  padding: 0,
                }}
              >
                <p
                  style={{
                    color: "#a6a6a6",
                    fontSize: "16px",
                    margin: 0,
                  }}
                >
                  {i18n.wbs.calculating.modal.subtitle}
                </p>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                autoFocus
                className={classes.confirmButton}
                onClick={() => {
                  this.handleConfirmRecalculation();
                }}
              >
                {i18n.yes}
              </Button>
              <Button onClick={this.handleModalToggle(false)} color="secondary">
                {i18n.no}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div
          ref="container"
          className={classes.gridContainer1}
          style={{
            overflow: "hidden!important",
            visibility: WBSStore.display3D,
          }}
        >
          <XeokitViewer
            display3D={WBSStore.display3D}
            showCube={WBSStore.cubeIsVisible}
            largeWidth={ProjectStore.leftTab === ELeftMenuTab.CLOSED}
            cubeIsInitialized={WBSStore.cubeIsInitialized}
          />
          {Render3dStore.loadingViewer && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                backgroundColor: "rgba(250, 250, 250, 1)",
                width: "100%",
                height: "calc(100% + 30px)",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CircularProgress
                size={50}
                style={{
                  margin: "0 auto",
                  color: "#9FB408",
                }}
              />
            </div>
          )}

          {!WBSStore.possibleLoading && !Render3dStore.loadingViewer && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "calc(100% + 30px)",
                backgroundColor: "rgba(250, 250, 250, 1)",
              }}
            >
              <NoResultsFound
                replaceTarget={i18n.library.message.noIFCforRender}
                replaceSubtarget={i18n.library.message.noIFCforRenderSub}
              />
            </div>
          )}
          {Render3dStore.toolbarLoading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                backgroundColor: "rgba(250, 250, 250, 0.5)",
                width: "100%",
                height: "calc(100% + 30px)",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CircularProgress
                size={50}
                style={{
                  margin: "0 auto",
                  color: "#9FB408",
                }}
              />
            </div>
          )}
        </div>
        {WBSStore.replicateModal && (
          <ReplicateModal
            selectedLine={WBSStore.selectedLine}
            dataList={WBSStore.dataTable}
          />
        )}
        {WBSStore.ExportByGroupModal && (
          <ExportByGroupModal
            selectedLine={WBSStore.selectedLine}
            dataList={WBSStore.dataTable}
          />
        )}
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(WBS);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/pages/WBS.tsx